import { inject } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './hypotheken-renteoverzicht.content.json';

export const contentInitializer = () => {
    const contentService = inject(ApContentService);
    contentService.addContentItems(content);
};
